// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PTAu","input":"styles_input__1q2Gp"};